module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/icons/faq-535d6ead023a26ccc8d1ec6563fd4130.svg&quot;;"